<template>
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-12">

 <article class="blog-single">
  <h1 class="single-title">{{ blog.title }}</h1>

  <div class="single-meta">
    🗓 {{ filterDate(blog.created_at) }} • ✍ Admin
  </div>


  <div class="single-content">
    <div v-html="blog.content"></div>
  </div>
   <div class="d-flex">
       <!-- <a  v-on:click="shareApp(blog,title)"  class="read-more">Share  <i class="fa fa-share"></i></a> -->
      </div>
</article>




          </div>
        </div>
      </div>

</template>


 <script>
          import moment from 'moment'
 export default {
     name: 'App',
      components: { },
     data(){
         return {
          proxyUrl: process.env.VUE_APP_API_URL,
             message:{id:''},
                role:'false',
                phone:'',
                blog:{},
                 settings:{bingwa:{}},
         }
     },
     created(){
        this.message.id= this.$route.params.id;
        this.getBlogs();
        this.getDiscount();
     },
     methods: {
                  async shareApp(title) {
  await Share.share({
    title: title,
    text: title,
    url: this.settings.playstore.rate,
    dialogTitle: 'Share App'
  })
},
         getDiscount(){
            this.message={mpesa:'0',airtel:'0',bonga:'0',airtime:'0',airtime2:'0',send_money:'0'};
                const uri =`/api/auth/discount`;
                this.$axios.get(uri).then((response) => {
                    this.settings=response.data;
                }).catch(error => {

                });
            },
         getBlogs(){
                let uri =`/api/auth/getBlogs`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.blogs=response.data;
                }).catch(warning => {

                });
            },
         getBlogs(){
                let uri =`/api/auth/getBlog/${this.message.id}`;
                this.$axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                   this.blog=response.data;
                }).catch(warning => {

                });
            },
            async routerPage(id){
             this.$router.push({name: 'buy_offers', params: { id }});
            },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            filterDate(date){
                return moment(String(date)).format('DD/MM/YYYY HH:mm')
            },
            excerpt(html, words = 25) {
    if (!html) return ''

    // Remove HTML tags
    const text = html.replace(/<[^>]*>/g, '')

    // Limit words
    return text.split(' ').slice(0, words).join(' ') + '...'
  }
     },

 }

</script>



// WEBPACK FOOTER //
// src/components/blog.vue